export default __webpack_public_path__ + "static/media/project_post_placeholder.540d0d7f.png";